import React, { useEffect, useState } from "react";
import MyNavbar from "../component/navbar";
import { Col, Container, Row, Button } from "react-bootstrap";
import MyFooter from "../component/footer";
import { Ellipsis } from "react-awesome-spinners";
import { getTerms } from "../ApiAction/api"

export default function Privacy(props) {

  const [content, setcontent] = useState("");
  const [loader, setloader] = useState(false);

  useEffect(() => {
    getCms();
  }, []);

  async function getCms() {
    try {
      setloader(true);
      let { content } = await getTerms("privacy");
      setcontent(content)
      setTimeout(function () {
        setloader(false);
      }, 1000)
    } catch (err) {
      setloader(false);
    }
  }


  return (
    <>
      <MyNavbar />
      <section className="privacy_page">
        <Container>
          {loader ? <div className="text-center">
            <Ellipsis className="loading mx-auto" color="#fc03f4" />
          </div>
            : <div dangerouslySetInnerHTML={{ "__html": content }} />
          }
        </Container>
      </section>
      <MyFooter />
    </>
  );
}
